import Api from '@/api/config/_api_config.js'
import cca_api from '@/api/api.js'

// Compte à rebours de la licence, demandé par le routeur à chaque changement de page (05/10/2026) : les appels
// simultanés partagent la même requête et une réponse sert 60 s, secondes restantes recalculées.
const COMPTE_A_REBOURS_MS = 60000
let compteARebours = null

export default {

    getListeSourceDepense(){
        const promise = Api().get('/roles/source-depense');
        return promise.then((response) => response.data)
    },

    updateUserProfil(data) {
        const promise = Api().post('/users/update', data)
        return promise.then((response) => response.data)
    },

    updateUserPassword(data) {
        const promise = Api().post('/users/update/password', data)
        return promise.then((response) => response.data)
    },

    getRolePersonnels() {
        const promise = cca_api.clinique().get('/accessibilites/users/roles')
        return promise.then((response) => response.data)
    },

    getInfoCliniqueActive() {
        const promise = Api().get('/config/clinique')
        return promise.then((response) => response.data)
    },

    getCountDown() {
        if (!compteARebours || (compteARebours.recu && Date.now() - compteARebours.recu >= COMPTE_A_REBOURS_MS)) {
            const entree = { recu: 0 }
            entree.promesse = cca_api.clinique().get('/countdown').then(response => {
                entree.recu = Date.now()
                return response.data
            }, erreur => {
                if (compteARebours === entree) compteARebours = null
                throw erreur
            })
            compteARebours = entree
        }
        const entree = compteARebours
        return entree.promesse.then(donnees => {
            const copie = donnees === undefined ? donnees : JSON.parse(JSON.stringify(donnees))
            const ecoule = Math.floor((Date.now() - entree.recu) / 1000)
            const restant = copie && copie.duree_restant
            if (ecoule > 0 && restant && typeof restant.total_secondes === 'number') restant.total_secondes -= ecoule
            return copie
        })
    },
}